interface CriticalStrongPointsEmptyProps {
  point: string;
  text: string;
  color: "red" | "green";
}
const CriticalStrongPointsEmpty: React.FC<CriticalStrongPointsEmptyProps> = ({
  point,
  text,
  color,
}) => {
  return (
    <div className="strengths-critical-container-number">
      <h1 className={`strengths-critical-title ${color} small`}>{point}</h1>
      <p className="strengths-critical-text">{text}</p>
    </div>
  );
};

export default CriticalStrongPointsEmpty;
